import { Button, Typography } from "@mui/material";
import Page from "material-ui-shell/lib/containers/Page";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import CustomPaper from "../../components/CustomPaper";
import { FormProvider, useForm } from "react-hook-form";
import CampoTexto from "../../components/campos/CampoTexto";
import { usePasswordConfirm } from "../../services/passwordconfirm.service";
import { RespuestaAdapter } from "../../adapters";
import { useSnackbar } from "notistack";
import MensajeVar from "../../var/Mensaje.var";
const PasswordConfirm = () => {
    const intl = useIntl();
    const theme = useTheme();
    let { token } = useParams();
    const navigate = useNavigate();
    const [{ data, loading, error }, sendData] = usePasswordConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const defaultValues = {
        rcl_contrasena: "",
        confirma_contrasena: "",
    };
    const formulario = useForm({
        mode: "onBlur",
        defaultValues: defaultValues,
    });
    const contrasena = useRef();
    contrasena.current = formulario.watch("rcl_contrasena", "");
    formulario.register("confirma_contrasena", {
        validate: (value) =>
            value === contrasena.current || "La contraseña no coincide",
    });
    const send = (data) => {
        sendData({
            data: { ...data, token: token },
            updatedAt: new Date().toISOString(),
        });
    };
    const formError = (error) => {
        console.error(error);
    };
    useEffect(() => {
        if (!loading && data) {
            const respuesta = RespuestaAdapter(data);

            if (respuesta.success) {
                enqueueSnackbar(respuesta.mensaje, {
                    variant: MensajeVar.variant.snackbar.SUCCESS,
                    anchorOrigin: MensajeVar.snackConfig.defecto,
                });
                navigate("/signin", { replace: true });
            } else {
                enqueueSnackbar(respuesta.mensaje, {
                    variant: MensajeVar.variant.snackbar.ERROR,
                    anchorOrigin: MensajeVar.snackConfig.defecto,
                });
            }
        }
        return () => {};
    }, [loading]);

    return (
        <Page
            pageTitle={intl.formatMessage({
                id: "password_confirm",
                defaultMessage: "Password confirm",
            })}
            onBackClick={() => {
                navigate(-1);
            }}
        >
            <CustomPaper elevation={6}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: `100%`,
                    }}
                >
                    <Typography component="h1" variant="h5">
                        {intl.formatMessage({
                            id: "password_confirm",
                            defaultMessage: "Password confirm",
                        })}
                    </Typography>

                    <FormProvider {...formulario}>
                        <form
                            style={{ marginTop: theme.spacing(1) }}
                            onSubmit={formulario.handleSubmit(send, formError)}
                            noValidate
                        >
                            <CampoTexto
                                control={formulario.control}
                                fullWidth
                                name="rcl_contrasena"
                                /* style={{ width: "80%" }} */
                                rules={{
                                    required: "Introduzaca su nueva contraseña",
                                    minLength: {
                                        value: 7,
                                        message:
                                            "La contraseña debe contener al menos 7 caracteres",
                                    },
                                }}
                                label={intl.formatMessage({
                                    id: "password",
                                    defaultMessage: "Password",
                                })}
                                type="password"
                                variant="outlined"
                                margin="normal"
                            />
                            <CampoTexto
                                control={formulario.control}
                                fullWidth
                                name="confirma_contrasena"
                                /* style={{ width: "80%" }} */
                                rules={{
                                    required: "Confirme su contraseña",
                                }}
                                label={intl.formatMessage({
                                    id: "password_confirm",
                                    defaultMessage: "Confirm password",
                                })}
                                type="password"
                                variant="outlined"
                                margin="normal"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                style={{ margin: theme.spacing(3, 0, 2) }}
                            >
                                {intl.formatMessage({
                                    id: "password_reset",
                                    defaultMessage: "Reset Password",
                                })}
                            </Button>
                        </form>
                    </FormProvider>
                </div>
            </CustomPaper>
        </Page>
    );
};

export default PasswordConfirm;
